'use client';

import { EntryBaseFragment } from '@/__generated__/graphql';
import UnstyledAccordion from '@/components/UnstyledAccordion';
import { SIBLING_BRANCH_FRAGMENT } from '@/gql/fragments/entries.gql';
import { withFragment } from '@liquorice/gql-utils';
import Breadcrumbs from '../Breadcrumbs';
import Box from '../ui/Box';
import PagesTreeNavigationAccordionItem from './PagesTreeNavigation.AccordionItem';
import * as styles from './PagesTreeNavigation.css';

const PagesTreeNavigation = withFragment(
  SIBLING_BRANCH_FRAGMENT,
  (data, props: EntryBaseFragment) => {
    if (!data) return;

    const topLink = (
      <Box cx={{ p: 'xs' }}>
        <Breadcrumbs
          data={props}
          CtaButtonProps={{ whiteSpace: 'normal', color: 'black' }}
          CtaButtonClass={styles.breadcrumb}
        />
      </Box>
    );

    return (
      <Box cx={{ mT: { md: '3xl' }, mB: '3xl' }}>
        {topLink}
        <UnstyledAccordion>
          {data.children?.map((item, index) => {
            return item && <PagesTreeNavigationAccordionItem key={item.id} {...{ item, index }} />;
          })}
        </UnstyledAccordion>
      </Box>
    );
  }
);

export default PagesTreeNavigation;
